// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Directive,
  DoCheck,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  inject,
} from '@angular/core';

@Directive({
  selector: '[app-weekend-highlight]',
  standalone: true,
})
export class WeekendHighlightDirective implements OnInit, OnChanges, DoCheck {
  @Input('app-weekend-highlight') dateValue?: string | Date;

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngOnInit(): void {
    this.updateWeekendClass();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('dateValue' in changes) {
      this.updateWeekendClass();
    }
  }

  ngDoCheck(): void {
    this.updateWeekendClass();
  }

  private updateWeekendClass() {
    const date = this.dateValue ? new Date(this.dateValue) : undefined;
    const isWeekend = date ? date.getDay() === 0 || date.getDay() === 6 : false;
    if (isWeekend) {
      this.renderer.addClass(this.el.nativeElement, 'weekend-cell');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'weekend-cell');
    }
  }
}
